<div *ngIf="!elementsOptions.clientSecret">
  <h2>Loading ...... Please Wait</h2>
</div>
<div
  *ngIf="elementsOptions.clientSecret"
  class="p-4 m-2 rounded-md surface-card shadow-2 border-round">
  <div class="mb-3 text-3xl font-medium text-primary-500">Add Payment Method</div>
  <ngx-stripe-elements [stripe]="stripe!" [elementsOptions]="elementsOptions">
    <ngx-stripe-payment [options]="paymentElementOptions" />
  </ngx-stripe-elements>
</div>
<div class="flex flex-wrap w-full p-2 m-2 align-items-center surface-ground">
  <p-button
    class="w-full p-4 m-2 text-center rounded-md lg:w-4/12 bg-primary-500 disabled:bg-slate-300"
    severity="success"
    label="Add Card"
    (onClick)="addCard()"
    icon="pi pi-wallet" />
  <p-button
    class="w-full p-4 m-2 text-center rounded-md lg:w-4/12 bg-primary-500 disabled:bg-slate-300"
    severity="success"
    label="Cancel"
    (onClick)="cancel()"
    icon="pi pi-times-circle" />
</div>
